import { FlowConfig } from '@/components/SimplifiedSignup/Context/types';

import AnnualOfferScreensConfig from './Screens';

const AnnualOfferFlow: FlowConfig = {
	activeScreenKey: 'account',
	activeScreenConfig: AnnualOfferScreensConfig.account,
	name: 'AnnualOffer',
	pageName: 'annual_offer',
	screens: {
		account: AnnualOfferScreensConfig.account,
		payment: AnnualOfferScreensConfig.payment,
		handoff: AnnualOfferScreensConfig.handoff,
	},
	plan: 'yearly',
	allowChurned: true,
	hasFreeTrial: false,
	offerCountries: null,
	offerCurrencies: null,
	fauxAuth: true,
};

export default AnnualOfferFlow;
